import { supabase } from '../lib/supabase';
import { useAppSelector } from '@/state/store';
import { Link } from 'react-router';
import { X } from 'lucide-react';

export default function Settings() {
    const user = useAppSelector((state) => state.app.user);

    const handleLogout = async () => {
        await supabase.auth.signOut();
        window.location.href = '/';
    };

    return (
        <div
            style={{
                width: '85%',
                maxWidth: '800px',
                margin: '0 auto',
            }}
        >
            <Link
                to="/"
                style={{
                    position: 'absolute',
                    top: '0',
                    right: '0',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '8px',
                    color: '#666',
                    textDecoration: 'none',
                }}
            >
                <X size={24} />
            </Link>
            <h1>Settings</h1>
            {user && (
                <div>
                    <p>
                        Logged in as: <strong>{user.email}</strong>
                    </p>
                    <div style={{ marginTop: '20px' }}>
                        <button onClick={handleLogout}>Logout</button>
                    </div>
                </div>
            )}
        </div>
    );
}
